import { AccountMarket } from '@typings';
import { createAction } from 'typesafe-actions';

export const fetchMarketsRequest = createAction('markets/FETCH_MARKETS_REQUEST')();
export const fetchMarketsSuccess = createAction('markets/FETCH_MARKETS_SUCCESS')<AccountMarket[]>();
export const fetchMarketsFailure = createAction('markets/FETCH_MARKETS_FAILURE')();
